import { render, staticRenderFns } from "./MainInteresting.vue?vue&type=template&id=b7c3b8ea&scoped=true&"
import script from "./MainInteresting.vue?vue&type=script&lang=js&"
export * from "./MainInteresting.vue?vue&type=script&lang=js&"
import style0 from "./MainInteresting.vue?vue&type=style&index=0&id=b7c3b8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c3b8ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicDescr: require('/web/components/objects/public/Descr.vue').default})
